export const countdownTime = 3; // min
export const delay = 2000; // ms

export default {
    delay,
    countdownTime
};
